import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useSWR from 'swr';
import { storeDataFetcher } from '../../../datafetchers/Store';
import { getPriceType, isWhiteColor } from '../../../Utils/helper';
import { cardServedEvent } from '../../../Utils/StoreHomePageUtils';
import { ProductsGridNew } from '../../StoreCategoryPage/SubCategoryProducts/styled';
import { BannerSubTitle, BannerTitle } from '../BannersGrid/styled';
import ProductCard from '../ProductCard';
import LoadMoreButton from './LoadMoreButton';
import { BrowseSection } from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

function BrowseAllProducts(props) {
  const {
    totalProducts,
    products,
    productClickHandler,
    setChangeCartCount,
    showPrice,
    setShowLoader,
    happiness,
  } = props;
  const router = useRouter();
  useEffect(() => {
    cardServedEvent(products);
  }, []);

  const { data, error, mutate } = useSWR(
    `product_${products?._id}`,
    () => {
      // console.log("");
    },
    {
      fallbackData: products?.items,
      revalidateOnFocus: false,
      revalidateOnMount: false,
      revalidateOnReconnect: false,
    },
  );

  useEffect(() => {
    let cardIds = '';
    data?.map((element, index) => {
      let id = element?._id;
      index == 0 ? (cardIds = id) : (cardIds = cardIds + ',' + id);
    });
  }, [data?.length]);

  const fetchMoreData = () => {
    setShowLoader(true);

    fireEvent({
      category: 'clicked_cta',
      screen_name: 'STORE_HOME',
      parent: 'browse_all_products',
      cta: 'load_more_products',
      section_name: products?.heading,
      section_id: products?.itemId,
      shape: products?.itemType,
    });
    if (data?.length >= totalProducts) {
      return;
    }
    storeDataFetcher({
      skip: data?.length,
      limit: 10,
      lang: 'en',
      key: router.query.brand,
      type: getPriceType(),
    }).then((productData) => {
      const newData = productData;
      const oldData = data;
      let finalProductsData = [];
      if (newData?.data?.cards?.items?.length) {
        finalProductsData = [
          ...oldData,
          ...newData?.data?.cards?.items?.[0]?.items,
        ];
        mutate(finalProductsData, false);
        setShowLoader(false);
      } else {
        setShowLoader(false);
      }
    });
  };

  return (
    <div>
      <BrowseSection
        sectionBgColorEnd={products?.sectionBgColorEnd}
        sectionBgColorStart={products?.sectionBgColorStart}
        padding={
          !isWhiteColor(
            products?.sectionBgColorStart,
            products?.sectionBgColorEnd,
          )
        }
      >
        {products?.heading ? (
          <BannerTitle browse>
            <h2>{products?.heading} </h2>
          </BannerTitle>
        ) : null}
        {products?.subHeading ? (
          <BannerSubTitle>
            <h2>{products?.subHeading} </h2>
          </BannerSubTitle>
        ) : null}
        <ProductsGridNew
          happiness={happiness}
          id="allProducts"
          gridSize={products?.gridSize}
        >
          {data?.map((element, index) => {
            return (
              <ProductCard
                itemId={`element-${index}`}
                productData={element}
                width={'22%'}
                productClickHandler={productClickHandler}
                card={element}
                setChangeCartCount={setChangeCartCount}
                sectionName={products?.heading}
                sectionId={products?.itemId}
                showPrice={showPrice}
                browse={true}
                key={index}
              />
            );
          })}
        </ProductsGridNew>
        {data?.length < totalProducts ? (
          <LoadMoreButton fetchMoreData={fetchMoreData} />
        ) : null}
      </BrowseSection>
    </div>
  );
}

export default BrowseAllProducts;
